import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';

import * as fromApp from '../../store/app.reducers';
import * as DemoActions from './../store/demo.actions';
import * as ProfileAction from '../../profile/store/profile.actions';
import {AuthService} from '../../auth/auth.service';

@Component({
    selector: 'app-demo-audit',
    templateUrl: './demo-audit.component.html',
    styleUrls: ['./demo-audit.component.scss'],
    standalone: false
})
export class DemoAuditComponent implements OnInit, OnDestroy {

  id: string;
  routeSubscription: Subscription;

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.store.dispatch(
      new ProfileAction.ClearCharts()
    );
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        this.id = params.guid;
        this.store.dispatch(
          new DemoActions.GetDemo({id: this.id, saveAsDemo: true})
        );
      }
    );
  }

  isAnonymous(): Observable<boolean> {
    return this.authService.isAuthenticated();
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

}
